import Joi from 'joi';

export const DocumentSchema = Joi.object({
  title: Joi.string().required(),
  pined: Joi.string().required(),
  file: Joi.string().required(),
});
